export function mapImportErrors(message?: string, errors?: string[]) : string[] {
    if (errors && errors.length > 0) {
      return [...errors];
    }
    else if (message) {
      return [message];
    }
  
    return [];
  }